import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
import PositiveAction from "./PositiveAction";

const useStyles = makeStyles((theme) => ({
  progress: { position: "absolute", top: -15, left: 0 },
}));

export default function LoadingButton({ children, loading, ...props }) {
  const classes = useStyles();
  return (
    <PositiveAction disabled={loading || props.disabled} {...props}>
      {children}
      {loading && (
        <div
          style={{
            position: "relative",
            width: 28,
            marginLeft: 16,
          }}
        >
          <CircularProgress className={classes.progress} size={28} />
        </div>
      )}
    </PositiveAction>
  );
}
